/**
 * Assunto da area (Vitor, 16/09: "o header esta ficando cheio"). O menu de cima aponta pro assunto (Meu plano,
 * Financeiro) e as partes dele viram abas, cada uma com endereco proprio. A tela dentro de um assunto nao repete o
 * cabecalho: quem desenha o titulo e as abas e o assunto.
 */
import { createContext, useContext } from "react";

const Ctx = createContext(false);
export const ProvedorDeAssunto = Ctx.Provider;
export const useDentroDeAssunto = () => useContext(Ctx);
